/* i-avocat — comportamentul paginilor (formular cu tema aleasă, filtre, meniu, ancore) */
(function () {
  var MQ = window.matchMedia('(max-width: 759px)');
  function root() { return document.querySelector(MQ.matches ? '[data-variant="m"]' : '[data-variant="d"]') || document; }
  function scope(el) { return (el && el.closest('[data-variant]')) || root(); }
  function find(id) {
    if (!id) return null;
    var r = root(), c = [id, 'm-' + id, id.replace(/^m-/, '')];
    for (var i = 0; i < c.length; i++) { var e = r.querySelector('[id="' + c[i] + '"]'); if (e) return e; }
    var g = document.getElementById(id); return g && g.offsetParent !== null ? g : null;
  }
  function go(id, smooth) {
    var t = find(id); if (!t) return false;
    if (t.tagName === 'DETAILS') t.open = true;
    var pd = t.parentElement && t.parentElement.closest('details'); if (pd) pd.open = true;
    t.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }); return true;
  }
  var menu = document.getElementById('iav-menu');
  function openMenu() { if (menu) { menu.hidden = false; document.documentElement.style.overflow = 'hidden'; } }
  function closeMenu() { if (menu) { menu.hidden = true; document.documentElement.style.overflow = ''; } }
  function pick(a) {
    var s = scope(a).querySelector('[id="' + a.getAttribute('data-select') + '"]'); if (!s) return;
    var v = a.getAttribute('data-value');
    if (s.tagName === 'SELECT') {
      s.value = v;
      if (s.value !== v) { for (var i = 0; i < s.options.length; i++) { if (s.options[i].text.trim() === v || s.options[i].value === v) { s.selectedIndex = i; break; } } }
    } else {
      s.querySelectorAll('label').forEach(function (l) { if (l.textContent.trim() === v) { var i = l.querySelector('input'); if (i) i.checked = true; } });
    }
    s.style.boxShadow = '0 0 0 3px #8FB5B8'; setTimeout(function () { s.style.boxShadow = ''; }, 1600);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (href === '#iav-menu') { e.preventDefault(); openMenu(); return; }
    if (a.hasAttribute('data-menu-close')) { e.preventDefault(); closeMenu(); return; }
    if (a.hasAttribute('data-copy')) {
      e.preventDefault();
      try { navigator.clipboard.writeText(a.getAttribute('data-copy')); } catch (x) {}
      var lg = document.documentElement.lang; a.textContent = lg === 'en' ? 'Link copied' : lg === 'ru' ? 'Ссылка скопирована' : 'Linkul a fost copiat'; return;
    }
    if (a.hasAttribute('data-back') && history.length > 1 && document.referrer.indexOf(location.host) > -1) { e.preventDefault(); history.back(); return; }
    if (a.hasAttribute('data-select')) pick(a);
    var u; try { u = new URL(href, location.href); } catch (x) { return; }
    if (!u.hash || u.origin !== location.origin) { if (a.closest('#iav-menu')) closeMenu(); return; }
    var id = decodeURIComponent(u.hash.slice(1));
    var same = u.pathname === location.pathname && u.search === location.search;
    if (!same && a.closest('#iav-menu') && id === 'formular' && find('formular')) same = true;
    if (same) {
      if (a.closest('#iav-menu')) closeMenu();
      if (go(id, true)) { e.preventDefault(); try { history.replaceState(null, '', '#' + id); } catch (x) {} }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  /* Informații utile: categorii, căutare, „Mai multe articole” */
  function applyList(r) {
    var v = r.getAttribute('data-f') || 'all', q = (r.getAttribute('data-q') || '').toLowerCase().trim();
    var box = r.querySelector('[data-list]'), lim = box ? parseInt(box.getAttribute('data-shown') || box.getAttribute('data-list'), 10) : 0;
    var n = 0, k = 0, hidden = 0;
    r.querySelectorAll('[data-cat]').forEach(function (c) {
      var ok = (v === 'all' || c.getAttribute('data-cat').trim() === v) && (!q || c.textContent.toLowerCase().indexOf(q) >= 0);
      if (ok) n++;
      if (c.hasAttribute('data-featured')) { c.hidden = !ok; return; }
      if (ok) { k++; c.hidden = lim && k > lim; if (c.hidden) hidden++; } else { c.hidden = true; }
    });
    var em = r.querySelector('[data-empty]'); if (em) em.hidden = n > 0;
    var more = r.querySelector('[data-more]'); if (more) more.hidden = hidden === 0;
  }
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-filter]');
    if (f) {
      e.preventDefault(); var r = scope(f), v = f.getAttribute('data-filter');
      r.querySelectorAll('[data-filter]').forEach(function (b) {
        var on = b === f; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.style.background = on ? '#1C3541' : '#FFFFFF'; b.style.color = on ? '#FFFFFF' : '#1C3541'; b.style.borderColor = on ? '#1C3541' : '#D3DDE2';
      });
      r.setAttribute('data-f', v); applyList(r); return;
    }
    var m = e.target.closest('[data-more]');
    if (m) {
      var r2 = scope(m), box = r2.querySelector('[data-list]');
      if (box) { box.setAttribute('data-shown', parseInt(box.getAttribute('data-shown') || box.getAttribute('data-list'), 10) + parseInt(m.getAttribute('data-more'), 10)); applyList(r2); }
    }
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-search]')) return;
    var r = scope(e.target); r.setAttribute('data-q', e.target.value); applyList(r);
  });
  document.querySelectorAll('[data-list]').forEach(function (b) { applyList(scope(b)); });

  /* Contacte: programarea online (ziua, ora, tipul) */
  function summary(r) {
    var s = r.querySelector('[data-summary]');
    var d = r.querySelector('[data-pick="zi"][aria-pressed="true"]'), o = r.querySelector('[data-pick="ora"][aria-pressed="true"]');
    var t = r.querySelector('[data-pick="tip"][aria-pressed="true"]') || ((r.querySelector('[data-tip-radio] input:checked') || {}).parentNode);
    var txt = (d ? d.getAttribute('data-label') : '') + (o ? ', ' + ({ ru: 'в', en: 'at' }[(document.documentElement.lang || 'ro').slice(0, 2)] || 'ora') + ' ' + o.textContent.trim() : '') + (t ? ' · ' + t.textContent.trim().toLowerCase() : '');
    if (s && txt) s.textContent = txt;
    r.querySelectorAll('[data-booking]').forEach(function (h) { h.value = txt; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pick]'); if (!b) return;
    e.preventDefault(); var g = b.getAttribute('data-pick'), r = scope(b);
    r.querySelectorAll('[data-pick="' + g + '"]').forEach(function (x) {
      var on = x === b; x.setAttribute('aria-pressed', on ? 'true' : 'false');
      x.style.background = on ? '#FFFFFF' : 'transparent'; x.style.color = on ? '#1C3541' : '#FFFFFF'; x.style.borderColor = on ? '#FFFFFF' : 'rgba(213,224,228,0.4)';
    });
    summary(r);
  });
  document.addEventListener('change', function (e) { if (e.target.closest('[data-tip-radio]')) summary(scope(e.target)); });

  /* Articole: cuprinsul se construiește din titlurile textului */
  document.querySelectorAll('[data-rte]').forEach(function (rte) {
    var r = scope(rte), ol = r.querySelector('[data-toc]'), boxEl = r.querySelector('[data-toc-box]');
    if (!ol) return;
    var hs = rte.querySelectorAll('h2'), pre = ol.getAttribute('data-toc') === 'm' ? 'm-h' : 'h';
    if (hs.length < 2) return;
    hs.forEach(function (h, i) {
      var t = h.textContent.replace(/\s+/g, ' ').trim(); if (!t) return;
      h.id = pre + (i + 1);
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = t;
      a.style.cssText = ol.getAttribute('data-toc') === 'm'
        ? 'display:block;padding:8px 0;font-size:16px;color:#2C4C58;font-weight:600'
        : 'display:block;padding:6px 0 6px 14px;border-left:2px solid ' + (i ? '#DCE4E8' : '#1C3541') + ';color:' + (i ? '#33424C' : '#1C3541') + ';font-weight:' + (i ? '400' : '600');
      li.appendChild(a); ol.appendChild(li);
    });
    if (boxEl) boxEl.hidden = false;
  });

  /* după trimiterea unui formular: mesajul apare doar la formularul trimis */
  var fh = location.hash.slice(1);
  if (fh && document.getElementById(fh) && document.getElementById(fh).tagName === 'FORM') {
    document.querySelectorAll('form .iav-ok').forEach(function (p) { if (p.closest('form').id !== fh) p.remove(); });
  }
  function initial() { var h = decodeURIComponent(location.hash.slice(1)); if (h && h !== 'iav-menu') go(h, false); }
  if (document.readyState === 'complete') initial(); else window.addEventListener('load', initial);
})();

(function () {
  function ready() { return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'; }
  var n = 0, t = setInterval(function () {
    if (ready()) { document.querySelectorAll('[data-iav-cookie]').forEach(function (a) { a.hidden = false; }); clearInterval(t); }
    else if (++n > 40) clearInterval(t);
  }, 500);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-iav-cookie]'); if (!a) return;
    e.preventDefault(); if (ready()) window.privacyBanner.showPreferences();
  });
})();

/* Programarea online: zilele următoare (fără duminică), în limba paginii */
(function () {
  var L = (document.documentElement.lang || 'ro').slice(0, 2);
  var N = {
    ro: { d: ['Duminică','Luni','Marți','Miercuri','Joi','Vineri','Sâmbătă'], s: ['Du','Lu','Ma','Mi','Jo','Vi','Sâ'],
          m: ['ianuarie','februarie','martie','aprilie','mai','iunie','iulie','august','septembrie','octombrie','noiembrie','decembrie'],
          ms: ['ian.','feb.','mar.','apr.','mai','iun.','iul.','aug.','sept.','oct.','nov.','dec.'] },
    ru: { d: ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'], s: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
          m: ['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'],
          ms: ['янв.','февр.','мар.','апр.','мая','июн.','июл.','авг.','сент.','окт.','нояб.','дек.'] },
    en: { d: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'], s: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
          m: ['January','February','March','April','May','June','July','August','September','October','November','December'],
          ms: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'] } }[L] || null;
  if (!N) return;
  var groups = [];
  document.querySelectorAll('[data-pick="zi"]').forEach(function (b) { if (groups.indexOf(b.parentNode) < 0) groups.push(b.parentNode); });
  groups.forEach(function (g) {
    var bs = g.querySelectorAll('[data-pick="zi"]'), d = new Date(); d.setHours(12, 0, 0, 0);
    bs.forEach(function (b) {
      do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0);
      var long = N.d[d.getDay()] + ', ' + d.getDate() + ' ' + N.m[d.getMonth()];
      b.setAttribute('data-label', long);
      var sp = b.querySelectorAll('span');
      if (sp.length >= 2) { sp[0].textContent = N.s[d.getDay()]; sp[1].textContent = d.getDate() + ' ' + N.ms[d.getMonth()]; }
    });
    var on = g.querySelector('[data-pick="zi"][aria-pressed="true"]'); if (on) on.click();
  });
})();

/* Formulare de contact: e-mail opțional în formularele scurte (telefon) și date pentru conversiile îmbunătățite Google Ads */
(function () {
  try { if (location.search.indexOf('contact_posted') === -1) sessionStorage.removeItem('iav_ec'); } catch (err) {}
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/contact') === -1) return;
    var opt = f.querySelector('input[data-iav-email-optional]');
    if (opt && !opt.value.trim()) opt.value = 'office@i-avocat.md';
    var em = f.querySelector('input[name="contact[email]"]');
    var email = em ? em.value.trim().toLowerCase() : '';
    if (/@i-avocat\.md$/.test(email) || email.indexOf('@') < 1) email = '';
    var tel = f.querySelector('input[type="tel"]');
    var phone = tel ? tel.value.replace(/[^\d+]/g, '') : '';
    if (/^00\d{8,}$/.test(phone)) phone = '+' + phone.slice(2);
    else if (/^0\d{8}$/.test(phone)) phone = '+373' + phone.slice(1);
    else if (/^373\d{8}$/.test(phone)) phone = '+' + phone;
    if (!/^\+\d{8,15}$/.test(phone)) phone = '';
    try { sessionStorage.setItem('iav_ec', JSON.stringify({ email: email, phone_number: phone })); } catch (err) {}
  }, true);
})();
